module.exports = __webpack_public_path__ + "img/search-icon.7e3f2fd3.svg";